import { uploadFile as uploadFileApi } from '@/api/storage'
import i18n from '@/i18n'
import { notification, Progress } from 'ant-design-vue'
import observer from './observer'

/**
 *
 * @param {FormData} data
 * @returns
 */
export function uploadFile(data) {
  let key = String(Date.now())
  let timer = null

  const instance = observer.$createElement({
    data() {
      return {
        percent: 0,
        status: ''
      }
    },
    render(h) {
      return h(Progress, {
        props: {
          percent: this.percent,
          strokeColor: this.status
        }
      })
    }
  })

  const _filename = data.get('file').name

  const nmsg =
    _filename.length > 22
      ? _filename.substring(0, 19) + '...'
      : _filename

  notification.open({
    key,
    message: `${i18n.tc('common.Upload')}:${nmsg}`,
    description: instance,
    placement: 'bottomRight',
    duration: null,
    onClose() {
      key = null
      if (timer !== null) {
        clearTimeout(timer)
      }
      instance.componentInstance.$destroy()
    }
  })

  return uploadFileApi(data, ({ loaded, total }) => {
    instance.componentInstance.percent = parseInt(
      (loaded / total) * 100 || 0
    )
  }).catch(err => {
    console.error(err)
    instance.componentInstance.status = 'exception'
    return Promise.reject(err)
  }).then(url => {
    if (key !== null) {
      timer = window.setTimeout(() => {
        clearTimeout(timer)
        timer = null
        notification.close(key)
      }, 3000)
    }
    return url
  })
}
